import Qs from "qs";
import URI from "urijs";
import AppConfig from "util/AppConfig";
const ACCEPTED_PROTOCOLS = ["http:", "https:"];
const qualifyRelativeURLWithCurrentHostname = (url) => {
  const uri = new URI(url);
  if (!uri.hostname() || !uri.scheme()) {
    const currentLocation = new URI(window.location);
    return uri.absoluteTo(currentLocation).toString();
  }
  return url;
};
const URLUtils = {
  qualifyUrl(url) {
    var _a;
    const parsedUrl = new URI(url);
    if (parsedUrl.is("absolute")) {
      return url;
    }
    const absoluteServerUrl = qualifyRelativeURLWithCurrentHostname((_a = AppConfig.gl2ServerUrl()) != null ? _a : "");
    return new URI(absoluteServerUrl + url).normalizePathname().toString();
  },
  appPrefixed(url) {
    return URLUtils.concatURLPath(AppConfig.gl2AppPathPrefix(), url);
  },
  getParsedSearch(location) {
    let search = {};
    let query = location.search;
    if (query) {
      if (query.indexOf("?") === 0 && query.length > 1) {
        query = query.substr(1, query.length - 1);
        search = Qs.parse(query);
      }
    }
    return search;
  },
  getParsedHash(location) {
    let result = {};
    let { hash } = location;
    if (hash) {
      if (hash.indexOf("#") === 0 && hash.length > 1) {
        hash = hash.substr(1, hash.length - 1);
        result = Qs.parse(hash);
      }
    }
    return result;
  },
  replaceHashParam(name, newValue) {
    const origHash = this.getParsedHash(window.location);
    origHash[name] = newValue;
    window.location.replace(`#${Qs.stringify(origHash)}`);
  },
  concatURLPath(...allArgs) {
    const args = Array(allArgs.length);
    for (let i = 0; i < allArgs.length; i++) {
      args[i] = allArgs[i];
    }
    const joinedPath = `/${args.join("/")}`;
    return joinedPath.replace(/[/]+/g, "/");
  },
  isValidURL(str) {
    let isValid = true;
    try {
      new URL(str);
    } catch (ignored) {
      isValid = false;
    }
    return isValid;
  },
  hasAcceptedProtocol(string, acceptedProtocols = ACCEPTED_PROTOCOLS) {
    const url = new URL(string);
    return acceptedProtocols.includes(url.protocol);
  },
  getPathnameWithoutId(pathname) {
    return pathname.replace(/\/([0-9a-f]{24}|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?=\/|$)/gi, "").slice(1);
  },
  currentPathname() {
    return window.location.pathname;
  },
  currentPathnameWithoutPrefix() {
    return URLUtils.stripPrefixFromPathname(URLUtils.currentPathname());
  },
  stripPrefixFromPathname(path) {
    if (!path) {
      return path;
    }
    const rawPathPrefix = AppConfig.gl2AppPathPrefix();
    const pathPrefix = (rawPathPrefix == null ? void 0 : rawPathPrefix.length) > 1 && rawPathPrefix.endsWith("/") ? rawPathPrefix.slice(0, -1) : rawPathPrefix;
    const pathPrefixLength = !pathPrefix || pathPrefix === "" || pathPrefix === "/" ? 0 : pathPrefix.length;
    return path.slice(pathPrefixLength);
  }
};
export default URLUtils;
export const {
  appPrefixed,
  getParsedHash,
  getParsedSearch,
  getPathnameWithoutId,
  qualifyUrl,
  replaceHashParam,
  concatURLPath,
  isValidURL,
  hasAcceptedProtocol,
  currentPathname,
  currentPathnameWithoutPrefix,
  stripPrefixFromPathname
} = URLUtils;
